import { v4 as uuidv4 } from "uuid"

/**
 * Generates a unique ID for a new job posting
 * @returns A UUID string
 */
export const generateJobId = (): string => {
  return uuidv4()
}

/**
 * Generates a complete application URL for a job posting
 * @param jobId The UUID of the job posting
 * @returns A complete URL string for the job application
 */
export const generateJobUrl = (jobId: string): string => {
  const frontendUrl = import.meta.env.VITE_FRONTEND_URL || "https://deliver.hived.space"

  // Ensure the URL doesn't have a trailing slash before adding the path
  const baseUrl = frontendUrl.endsWith("/") ? frontendUrl.slice(0, -1) : frontendUrl

  // Create the complete URL with the job ID
  return `${baseUrl}/basic-details?jobId=${jobId}`
}

/**
 * Creates both a job ID and URL in one function call
 * @returns An object containing the generated job ID and URL
 */
export const createJobIdAndUrl = (): { jobId: string; jobUrl: string } => {
  const jobId = generateJobId()
  const jobUrl = generateJobUrl(jobId)
  return { jobId, jobUrl }
}
